import React from 'react';
import { m } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
export function AboutAuthor() {
  return <section className="bg-white py-14 sm:py-16" data-id="element-22" data-mp="2hf4lkrab19s1">
      <div className="mx-auto grid max-w-5xl gap-10 px-6 sm:px-8 lg:grid-cols-2 lg:items-center" data-id="element-23" data-mp="2m9h3gww4ud1o">
        <m.img initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} src="https://cdn.magicpatterns.com/patterns/generated-images/61efd24c-6489-4bdc-94f4-e4988dc0753f.jpg" alt="El equipo de Balonmano Pro 360 en el banquillo" loading="lazy" decoding="async" className="mx-auto w-full max-w-[400px] rounded-2xl object-cover shadow-media" data-id="element-24" data-mp="2q8hjk7n871kz" />

        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-center lg:text-left" data-id="element-25" data-mp="3dykb8mn8a5j2">
          <SectionTag data-id="element-26" data-mp="25s8kb1epe39h">Acerca de Balonmano Pro 360</SectionTag>

          <div className="mt-5 rounded-2xl border-l-4 border-azul bg-azul-light p-6 text-left" data-id="element-27" data-mp="25t065kii0mmk">
            <QuoteIcon size={22} className="text-azul" data-id="element-28" data-mp="20rauc2ngc4xf" />
            <p className="mt-3 text-lg font-semibold leading-relaxed text-azul" data-id="element-29" data-mp="1vukijriojvht">
              "He volcado en este sistema los esquemas reales que utilizamos para transformar entrenamientos
              improvisados en sesiones con criterio profesional. Menos búsqueda en YouTube y más balonmano
              real en la pista."
            </p>
            <p className="mt-4 text-base leading-relaxed text-gris-texto" data-id="element-30" data-mp="1i2xh7d9vrws6">
              Entrenadores del balonmano base español con más de una década de experiencia en cantera.
              Formados en la pista pequeña, en el vestuario ruidoso y en la reunión de padres difícil. Todo
              lo que encontrarás en Balonmano Pro 360 viene de ahí. No de la teoría. De la pista real.
            </p>
          </div>
        </m.div>
      </div>
    </section>;
}